import { render, staticRenderFns } from "./CheckPopup.vue?vue&type=template&id=39a8ed96&scoped=true&"
import script from "./CheckPopup.vue?vue&type=script&lang=js&"
export * from "./CheckPopup.vue?vue&type=script&lang=js&"
import style0 from "./CheckPopup.vue?vue&type=style&index=0&id=39a8ed96&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a8ed96",
  null
  
)

export default component.exports